

/**
 * Create a popup tooltip and inject the message content
 * @var field = top-level field DOM
 * @var signaturePad = signature pad object (canvas)
**/
export function Create( content ){
	
	// if the popup content doesn't exist
	if ($(document).find('.tooltip').length > 0){
		var tooltip = $(document).find('.tooltip');
	} else {
		var tooltip = $('<div class="tooltip" style="display: none;"><div class="tooltip__inner"><div class="tooltip__close"><span class="fa fa-close"></span></div><div class="tooltip__content"></div></div></div>');
	}

	tooltip.find('.tooltip__content').html( content );
	$('body').append(tooltip);
	tooltip.fadeIn('fast');
	
	// on click of background
	tooltip.on('click tap', function(e){
		if ($(e.target).closest('.tooltip__inner').length <= 0){ 
			tooltip.fadeOut(
				'fast', 
				function(){
					tooltip.remove()
				}
			);
		}
	});
	
	// click of close button
	tooltip.on('click tap', '.tooltip__close', function(e){
		tooltip.fadeOut('fast', function(){ tooltip.remove() } );
	});
}




